import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgProfileAlt = function SvgProfileAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#profile-alt_svg__clip0)"
  }, React.createElement("path", {
    d: "M11.975 6c1.078 0 2.016.89 2.016 2.016a2 2 0 01-2.016 2.015A2 2 0 019.96 8.016C9.96 6.89 10.897 6 11.975 6zm0-2.016A3.981 3.981 0 007.991 7.97a3.981 3.981 0 003.984 3.984A3.981 3.981 0 0015.96 7.97a3.981 3.981 0 00-3.985-3.985z"
  }), React.createElement("path", {
    d: "M11.975 0A11.943 11.943 0 00.022 11.953c0 6.61 5.344 11.953 11.953 11.953 6.61 0 11.953-5.343 11.953-11.953C23.928 5.343 18.584 0 11.975 0zM6.303 20.11a5.993 5.993 0 015.719-4.172c2.625 0 4.922 1.734 5.719 4.171-1.594 1.125-3.563 1.782-5.719 1.782s-4.125-.657-5.719-1.782zm12.985-1.407c-1.266-2.86-4.125-4.781-7.313-4.781-3.187 0-6.047 1.922-7.312 4.781-1.641-1.781-2.672-4.172-2.672-6.75 0-5.484 4.453-9.984 9.984-9.984s9.984 4.5 9.984 9.984a9.822 9.822 0 01-2.671 6.75z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "profile-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.022)"
  }))));
};

export default SvgProfileAlt;